import { Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SurveyAnswerRequest } from "../model/survey-answer-request.model";
import { SurveyQuestion } from "../../../../../shared-lib/src/public-api";

import {
  PersistenceAction,
  QuestionCtrlType,
  SurveyAnswer,
} from "../../../../../shared-lib/src/public-api";

@Injectable({ providedIn: "root" })
export class QuestionControlUtil {
  constructor() {}

  private createFormControl(value: string, isRequiredField: boolean) {
    if (isRequiredField) {
      return new FormControl(value, Validators.required);
    } else {
      return new FormControl(value);
    }
  }

  private findAnswer(
    question: SurveyQuestion,
    answers: SurveyAnswer[]
  ): SurveyAnswer {
    return answers.find((answer) => {
      return answer.surveyQuestionId === question.id;
    });
  }

  private getAnswerValue(
    question: SurveyQuestion,
    answers: SurveyAnswer[]
  ): string {
    const foundAnswer = this.findAnswer(question, answers);
    if (foundAnswer) {
      if (question.questionCtrlTypeId === QuestionCtrlType.MULTIPLE_CHOICE) {
        return `${foundAnswer.questionOptionId}`;
      } else if (
        question.questionCtrlTypeId === QuestionCtrlType.NUMBERIC_TEXT
      ) {
        return foundAnswer.questionAnswer;
      } else if (question.questionCtrlTypeId === QuestionCtrlType.FREE_TEXT) {
        return foundAnswer.questionAnswer;
      }
    } else {
      return "";
    }
  }

  toFormGroup(questions: SurveyQuestion[], answers: SurveyAnswer[]) {
    const group: any = {};
    questions.forEach((question) => {
      const answerValue = this.getAnswerValue(question, answers);
      group[question.id] = this.createFormControl(
        answerValue,
        question.requireAnswer
      );
    });
    return new FormGroup(group);
  }

  toSaveAnswers(
    username: string,
    visitorId: number,
    questions: SurveyQuestion[],
    form: any
  ): SurveyAnswerRequest {
    const surveyAnswerId = 0;
    const surveyAnswers = [];
    questions.forEach((qs) => {
      if (qs.questionCtrlTypeId === QuestionCtrlType.MULTIPLE_CHOICE) {
        const surveyAnswer = {
          id: surveyAnswerId,
          visitorId,
          surveyQuestionId: qs.id,
          questionOptionId: form[qs.id],
          questionAnswer: null,
          createdBy: username,
          updatedBy: username,
          modelAction: PersistenceAction.INSERT,
        } as SurveyAnswer;
        surveyAnswers.push(surveyAnswer);
      }
      if (qs.questionCtrlTypeId === QuestionCtrlType.FREE_TEXT) {
        const surveyAnswer = {
          id: surveyAnswerId,
          visitorId,
          surveyQuestionId: qs.id,
          questionOptionId: 0,
          questionAnswer: form[qs.id],
          createdBy: username,
          updatedBy: username,
          modelAction: PersistenceAction.INSERT,
        } as SurveyAnswer;
        surveyAnswers.push(surveyAnswer);
      }
      if (qs.questionCtrlTypeId === QuestionCtrlType.NUMBERIC_TEXT) {
        const surveyAnswer = {
          id: surveyAnswerId,
          visitorId,
          surveyQuestionId: qs.id,
          questionOptionId: 0,
          questionAnswer: `${form[qs.id]}`,
          createdBy: username,
          updatedBy: username,
          modelAction: PersistenceAction.INSERT,
        } as SurveyAnswer;
        surveyAnswers.push(surveyAnswer);
      }
    });
    const result = {
      answers: surveyAnswers,
    } as SurveyAnswerRequest;
    return result;
  }

  toUpdateAnswers(
    username: string,
    answers: SurveyAnswer[],
    questions: SurveyQuestion[],
    form: any
  ): SurveyAnswerRequest {
    const surveyAnswers = [];
    questions.forEach((qs) => {
      const surveyAnswer = answers.find((answer) => {
        return answer.surveyQuestionId === qs.id;
      });
      if (qs.questionCtrlTypeId === QuestionCtrlType.MULTIPLE_CHOICE) {
        surveyAnswer.questionOptionId = form[qs.id];
      }
      if (qs.questionCtrlTypeId === QuestionCtrlType.FREE_TEXT) {
        surveyAnswer.questionAnswer = form[qs.id];
      }
      if (qs.questionCtrlTypeId === QuestionCtrlType.NUMBERIC_TEXT) {
        surveyAnswer.questionAnswer = `${form[qs.id]}`;
      }
      surveyAnswer.updatedBy = username;
      surveyAnswer.modelAction = PersistenceAction.UPDATE;
      surveyAnswers.push(surveyAnswer);
    });
    const result = {
      answers: surveyAnswers,
    } as SurveyAnswerRequest;
    return result;
  }
}
